export default __webpack_public_path__ + "static/media/dpd-local.42dc3d13.svg";